module.exports = __webpack_public_path__ + "img/interactive.47486257.svg";